import { render, staticRenderFns } from "./SelectorBuilder.vue?vue&type=template&id=630b0cd3&scoped=true&"
import script from "./SelectorBuilder.vue?vue&type=script&lang=js&"
export * from "./SelectorBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SelectorBuilder.vue?vue&type=style&index=0&id=630b0cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b0cd3",
  null
  
)

export default component.exports